import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { GetNameDevSetList, NAME_DEV_SET } from '../../../function/NameDevSetModel';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import Calender2 from '../../atoms/Calendar/ItemCalenderEx';
import { GetTimeList } from './PhaseCurrent';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import DateInput from '../../atoms/Calendar/DateInput';

const useStyles = makeStyles(
  createStyles({
    labelStyle: {
      padding: '0px,50px,0px,0px',
    },
    itemBoxStyle: {
      marggin: '0px,0px,10px,10px',
    },
  })
);

//画面情報
export type PhaseCurrentSelectData = {
  devIndex: string; //デバイスインデックス
  selectDay: string; //選択日時
  selectTime: string; //選択時間
  minSec: number; //時間軸範囲
  maxSec: number; //時間軸範囲
  isLowPassFlg:boolean; //ローパスフィルタ
};

//画面リフレッシュタイプ
export type InitDataType = {
  nameDevList: NAME_DEV_SET[];
  selectData: PhaseCurrentSelectData;
};

type Props = {
  selectData: PhaseCurrentSelectData;
  initData: InitDataType;
  onSelectDataChangeEvent: (data: PhaseCurrentSelectData) => void;
};
const PhaseCurrentSelectItem: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  //console.debug(props);

  const [nameDebSetList, setNameDevSetList] = useState<ComboBoxItemType[]>();
  const [selectDevid, setSelectDevid] = useState<string>(props.selectData.devIndex);
  const [timeList, setTimeList] = useState<ComboBoxItemType[]>();
  const [selectDay, setSelectDay] = useState<string>(props.selectData.selectDay);
  const [selectTimeid, setSelectTimeid] = useState<number>(0);
  const lowPassFlg = props.selectData.isLowPassFlg;

  useEffect(() => {
    console.debug(['リフレッシュデータ', props.initData]);

    if (props.initData.selectData.devIndex == '0') {
      //初期化時は何もしない
      return;
    }
    var nameDevList = props.initData.nameDevList;
    var selData = props.initData.selectData;

    var cmdList: ComboBoxItemType[] = [];
    for (let i = 0; i < nameDevList.length; i++) {
      cmdList.push({
        index: nameDevList[i].DEV_INDEX,
        name: nameDevList[i].DEV_NO + ' ' + nameDevList[i].DEV_NAME,
      });
    }
    setNameDevSetList([...cmdList]);
    GetTimeList(selData.devIndex, selData.selectDay,selData.isLowPassFlg)
      .then((ret) => {
        var cmdList2: ComboBoxItemType[] = [];
        for (let i = 0; i < ret.length; i++) {
          cmdList2.push({
            index: i + 1,
            name: dayjs(ret[i]).format('HH:mm:ss'),
          });
        }
        //時間でソートを行う
        cmdList2.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          } else {
            return -1;
          }
        });
        setTimeList([...cmdList2]);
        setSelectDevid(selData.devIndex);
        setSelectDay(selData.selectDay);

        var time = cmdList2.find((row) => row.name == selData.selectTime);
        setSelectTimeid(time?.index ?? 0);
      })
      .catch((r) => {
        console.debug(['useEffect リフレッシュデータ catch', r]);
      })
      .finally(() => { });
  }, [props.initData]);

  useEffect(() => {
    setSelectDevid(props.selectData.devIndex);
    setSelectDay(props.selectData.selectDay);
  }, [props.selectData]);

  useEffect(() => {
    if (selectDevid === '0' || selectDay === '') {
      return;
    }

    console.debug(['-PhaseCurrentSelectItem LowPassFlg change', props.selectData.isLowPassFlg]);
    setTimeLists(
      selectDevid,
      selectDay,
      props.selectData.isLowPassFlg
    );
  }, [props.selectData.isLowPassFlg]);
  

  //選択データ変更時
  const setTimeLists = (devIndex: string, selectDay: string, isLowPassFlg :boolean) => {
    console.debug(['-PhaseCurrentSelectItem setTimeLists devIndex', devIndex]);
    var timeList: ComboBoxItemType[] = [];
    if (devIndex != '0' && selectDay != '') {
      GetTimeList(devIndex, selectDay,isLowPassFlg)
        .then((ret) => {
          //console.debug(['==ret==', ret]);
          for (let i = 0; i < ret.length; i++) {
            timeList.push({
              index: i + 1,
              name: dayjs(ret[i]).format('HH:mm:ss'),
            });
          }//時間でソートを行う
          timeList.sort(function (a, b) {
            if (a.name > b.name) {
              return 1;
            } else {
              return -1;
            }
          })
          setTimeList([...timeList]);

          props.onSelectDataChangeEvent({
            ...props.selectData,
            devIndex: devIndex,
            selectDay: selectDay,
            selectTime: timeList.length === 0 ? '' : timeList[0].name,
          });
        })
        .catch((r) => {
          console.debug(['-PhaseCurrentSelectItem  useEffect setTimeLists catch', r]);
        })
        .finally(() => { });
    }
  };

  /**
   * 機器情報変更イベント
   * @param event 
   */
  const ChangeDevSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setSelectDevid(String(event.target.value));
    setTimeLists(String(event.target.value), selectDay,lowPassFlg);
    console.debug(['-PhaseCurrentSelectItem ChangeDevSelect ', event.target.value]);
  };

  /**
   * カレンダー変更イベント
   * @param value 
   */
  const onChangeCalendarValue = (value: string) => {
    setSelectDay(value);
    setTimeLists(selectDevid, value,lowPassFlg);
    console.debug(['-PhaseCurrentSelectItem onChangeCalendarValue ', value, selectDevid]);
  };

  /**
   * 時間変更イベント
   * @param event 
   */
  const ChangeTimeSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var time = timeList?.find((row) => row.index == event.target.value);
    if (time) {
      setSelectTimeid(time.index);
      props.onSelectDataChangeEvent({
        ...props.selectData,
        selectTime: time.name,
      });
      console.debug(['-PhaseCurrentSelectItem ChangeTimeSelect ' , time?.name]);
    }
  };

  return (
    <table>
      <tr>
        <td colSpan={2}>
          <ItemComboBox
            label={t('PhaseCurrentSelectItem.機器', '機器:')}
            itemList={nameDebSetList}
            labelStyle={classes.labelStyle}
            itemBoxStyle={classes.itemBoxStyle}
            onChangeEvent={ChangeDevSelect}
            value={Number(selectDevid)}
          ></ItemComboBox>
        </td>
      </tr>
      <tr>
        <td>
          <DateInput
            label={t('PhaseCurrentSelectItem.計測日', '計測日:')}
            initialValue={selectDay}
            onDateChange={onChangeCalendarValue}
          ></DateInput>
        </td>
        <td>
          <ItemComboBox
            label={''}
            value={selectTimeid}
            itemList={timeList}
            onChangeEvent={ChangeTimeSelect}
          ></ItemComboBox>
        </td>
      </tr>
    </table>
  );
};
export default PhaseCurrentSelectItem;
